import axios from 'axios';
import types from '../../types';
/* eslint-disable */

export default {
  [types.GET_NEWS]: async (context, payload) => {
    try {
      const page = payload?.page || 1
      await axios.get(`news-action/get-user-news?page=${page}`).then((res) => {
        if(page === 1){
          context.commit('CLEAR_NEWS');
          context.commit('STORE_NEWS', res.data.data);
        } else {
          context.commit('STORE_NEWS', res.data.data);
        }});
    } catch (err) {
      console.error(err);
    }
  },
  [types.MARK_NEWS_SEEN]: async (context, payload) => {
    try {
      context.commit(types.MARK_NEWS_ITEM_READ, payload.id);
      await axios.post(`news-action/mark-seen`, payload);
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_NEWS]: ({ commit }, payload) => {
    commit('STORE_NEWS', payload);
  },
  [types.CLEAR_NEWS]: (context) => {
    context.commit('CLEAR_NEWS');
  },
};
